var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandedConfigTableHeader(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    filerule: "evenodd",
    clipRule: "evenodd",
    d: "M2.707 2.708a.677.677 0 0 0-.677.677v9.48a.677.677 0 0 0 .677.677H13.54a.677.677 0 0 0 .677-.677V5.417a.677.677 0 0 0-.677-.677H7.447a.677.677 0 0 1-.564-.302L5.73 2.708H2.707zM1.271 1.95c.38-.38.897-.595 1.436-.595h3.385c.227 0 .438.113.564.302l1.153 1.73h5.731a2.031 2.031 0 0 1 2.032 2.03v7.449a2.031 2.031 0 0 1-2.032 2.03H2.707a2.031 2.031 0 0 1-2.031-2.03v-9.48c0-.538.214-1.055.595-1.436z",
    fill: "#21314B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    filerule: "evenodd",
    clipRule: "evenodd",
    d: "M5.418 9.48c0-.375.303-.678.677-.678h4.063a.677.677 0 0 1 0 1.354H6.095a.677.677 0 0 1-.677-.677z",
    fill: "#21314B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandedConfigTableHeader);
export default __webpack_public_path__ + "static/media/ExpandedConfigTableHeader.3220a993ab84476ccaa9a94c1dd79336.svg";
export { ForwardRef as ReactComponent };